<script setup lang="ts">
import MmIcon from '../base/MmIcon.vue'
const props = withDefaults(defineProps<{ modelValue?: string; busy?: boolean }>(), { modelValue: '' })
const emit = defineEmits<{ 'update:modelValue': [value: string]; 'input-complete': [value: string]; submit: [value: string] }>()
const { t } = useI18n()
const input = ref<HTMLInputElement | null>(null)
let composing = false
const update = (event: Event) => {
  const value = (event.target as HTMLInputElement).value
  emit('update:modelValue', value)
  if (!composing) emit('input-complete', value)
}
defineExpose({ focusInput: () => input.value?.focus() })
</script>

<template>
  <header class="ex-head">
    <p class="t-display"><i18n-t keypath="t24d.spinningTitle"><template #accent><span class="t-serif">{{ t('t24d.spinning') }}</span></template></i18n-t></p>
    <form class="search big-search" role="search" @submit.prevent="!composing && emit('submit', props.modelValue.trim())">
      <MmIcon name="search" :size="20" />
      <label class="sr-only" for="explore-search">{{ t('ux.search') }}</label>
      <input id="explore-search" ref="input" type="search" maxlength="200" enterkeyhint="search" :placeholder="t('t24d.searchPlaceholder')" :value="modelValue" @input="update" @compositionstart="composing = true" @compositionend="composing = false; update($event)">
      <button class="btn btn-primary btn-sm" type="submit" :aria-busy="busy || undefined">{{ t('ux.search') }}</button>
    </form>
  </header>
</template>

<style scoped>
.ex-head { padding: 24px 0 8px; display: grid; gap: 16px; }
.ex-head .t-display .t-serif { color: var(--live); font-weight: 400; }
.mm-root .big-search { height: 56px; font-size: 17px; background: var(--surface); width: 100%; max-width: 640px; }
.big-search input { font-size: 17px; padding: 1px 2px; }
/* The form owns the focus border; reset the native/Tailwind input ring. */
.mm-root .big-search input:is(:focus, :focus-visible) { border: 0; outline: none; box-shadow: none; --tw-ring-shadow: 0 0 transparent; }
.big-search input::placeholder { color: var(--text-3); opacity: 1; }
</style>
